import { apiUrl } from '@/services/apiUrls'
import { ref } from 'vue'
import setupHeaders from '@/services/composables/setupHeaders'
import handleError from '@/services/composables/handleError'

let grants: any = undefined

export const getEmpGrants = async () => {
  if (!grants) {
    const url = apiUrl('EMP_GRANTS', 'acl/grants/emp')
    const additionalHeaders = null

    const headers = await setupHeaders(additionalHeaders)
    const requestOptions = new Request(url.toString(), { method: 'GET', body: null, headers })
    return fetch(requestOptions)
      .then(handleError)
      .then((data) => {
        grants = data.data
        return data
      })
      .catch((error) => {
        throw error
      })
  } else {
    return new Promise((resolve) => {
      resolve({ data: grants })
    })
  }
}

const checkGrant = <T>(resourceName: string, grant: string) => {
  const check = ref(false)
  if (grants) {
    const pageGrant: string[] = grants[resourceName]
    if (pageGrant && pageGrant.includes(grant)) {
      check.value = true
    } else {
      check.value = false
    }
  }

  const getUpdatedGrants = async () => {
    const { data: grantsData } = await getEmpGrants()
    const pageGrant: string[] = grantsData[resourceName]
    if (pageGrant && pageGrant.includes(grant)) {
      check.value = true
    } else {
      check.value = false
    }
  }

  if (!grants) {
    getUpdatedGrants()
  }

  return check
}

// Promise-based version of checkGrant that waits for grants to load
export const checkGrantAsync = async (resourceName: string, grant: string): Promise<boolean> => {
  
  // If grants are already loaded, check immediately
  if (grants) {
    const pageGrant: string[] = grants[resourceName]
    return pageGrant && pageGrant.includes(grant)
  }
  
  // If grants aren't loaded, wait for them to load
  const { data } = await getEmpGrants()
  grants = data
  const pageGrant: string[] = grants[resourceName]
  return pageGrant && pageGrant.includes(grant)
}

export default checkGrant
